<template>
  <center>
    <!-- <div v-if="duringSubmit" class="loading">
      <Loading/>
    </div> -->
    <div
      v-if="(isLoggedIn || handleLogin())"
      class="card card-body agatrs-card-style"
    >
      <Header pageTitle="Search" class="card-container"></Header>
      <!-- 1st Row -->
      <div class="row">

        <div class="col-md-3">
          <label for="AcsaRequisitionNumber">ACSA Requisition Number</label>
          <base-input
            id="AcsaRequisitionNumber"
            v-model="selectedAcsaRequisitionNumber"
            name="AcsaRequisitionNumber"
            placeholder="Requisition Number"
             @input="changeValue"
          ></base-input>
        </div>

        <div class="col-md-3">
          <label for="UsBuySell">US Buying or Selling</label>
          <v-select
            id="UsBuySell"
            v-model="selectedBuyOrSell"
            name="BuyOrSellDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="buyOrSellOptions"
            placeholder="Select"
             @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="status">Status</label>
          <v-select
            id="status"
            v-model="selectedStatus"
            name="StatusDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="statusOptions"
            placeholder="Select"
             @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="PartnerNation">Partner Nation</label>
          <v-select
            id="PartnerNation"
            v-model="selectedPartnerNation"
            name="PartnerNationDropdown"
            :reduce="(item) => item.countryId"
            label="name"
            :options="partnerNationOptions"
            placeholder="Select"
             @input="changeValue"

          ></v-select>
        </div>
      </div>

      <!-- 2nd Row -->
      <div class="row">
        <div class="col-md-3">
          <label for="FiscalYear">Fiscal Year</label>
          <v-select
            id="FiscalYear"
            v-model="selectedFiscalYear"
            :reduce="(item) => item.id"
            name="FiscalYear"
            label="label"
            :options="fiscalYears"
            placeholder="Select"
             @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="Theater">Operation / Theater</label>
          <v-select
            id="Theater"
            v-model="selectedOperationTheater"
            name="OperationTheaterDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="operationTheaterOptions"
            placeholder="Select"
             @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="PurchaseOrder">Purchase Order</label>
          <base-input
            id="PurchaseOrder"
            v-model="selectedPurchaseOrder"
            name="PurchaseOrder"
            placeholder="Purchase Order Number"
            @input="changeValue"

          ></base-input>
        </div>

        <div class="col-md-3">
          <label for="InvoiceNumber">Invoice Number</label>
          <base-input
            id="InvoiceNumber"
            v-model="selectedInvoiceNumber"
            name="InvoiceNumber"
            placeholder="Invoice Number"
            @input="changeValue"

          ></base-input>
        </div>
      </div>
      <!-- 3rd Row -->
      <div class="row">
        <div class="col-md-3">
          <label for="OrderNumber">Order Number</label>
          <base-input
            id="OrderNumber"
            v-model="selectedOrderId"
            name="OrderNumber"
            placeholder="Order Number"
            @input="changeValue"

          ></base-input>
        </div>

        <div class="col-md-3">
          <label for="MethodOfPayment">Method of Payment</label>
          <v-select
            id="MethodOfPayment"
            v-model="selectedMethodOfPayment"
            name="MethodOfPaymentDropdown"
            :reduce="(item) => item.paymentMethodId"
            label="name"
            :options="methodOfPaymentOptions"
            placeholder="Select"
            @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="LsssType">LSSS Type</label>
          <v-select
            id="LsssType"
            v-model="selectedLsssType"
            name="LsssTypeDropdown"
            :reduce="(item) => item.lssTypeId"
            label="name"
            :options="lsssTypeOptions"
            placeholder="Select"
            @input="changeValue"

          ></v-select>
        </div>

        <div class="col-md-3">
          <label for="CreatedBy">Created By</label>
          <v-select
            id="CreatedBy"
            v-model="selectedCreatedBy"
            name="CreatedByDropdown"
            :reduce="(item) => item.id"
            label="email"
            :options="createdByOptions"
            placeholder="Select"
            @input="changeValue"

            >
            <template v-slot:option="option">
              {{ option.firstName }} {{ option.lastName }}
              ({{ option.email }})
            </template>
          </v-select>
        </div>
      </div>
      <!-- 4th Row -->
      <div class="row">
        <div class="col-md-3">
          <label for="LogisticsUser">Assigned Logistics User</label>
          <v-select
            id="LogisticsUser"
            v-model="selectedAssignedLogisticsUser"
            name="AssignedLogisticsUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedLogisticsUserOptions"
            placeholder="Select"
            @input="changeValue"

          >
            <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
          </v-select>
        </div>

        <div class="col-md-3">
          <label for="FinanceUser">Assigned Finance User</label>
          
          <v-select
            id="FinanceUser"
            v-model="selectedAssignedFinanceUser"
            name="AssignedFinanceUserDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="assignedFinanceUserOptions"
            placeholder="Select"
            @input="changeValue"

          >
           <template v-slot:option="option">
      {{ option.nameLabel }}
    </template>
    </v-select>
        </div>
<div class="col-md-3">
          <label for="StartPrice">Start Price</label>
          <base-input
            id="StartPrice"
            min="0"
            v-model="selectedStartPrice"
            type="Number"
            name="StartPrice"
            placeholder="Start Price"
            @input="changeValue"

          ></base-input>
        </div>

        <div class="col-md-3">
          <label for="EndPrice">End Price</label>
          <base-input
            id="EndPrice"
            v-model="selectedEndPrice"
            min="0"
            name="EndPrice"
            placeholder="End Price"
            @input="changeValue"

          ></base-input>
        </div>
        
      </div>
      <!-- 5th Row -->
      <div class="row">
        
        <div class="col-md-3">
          <label for="OrderDateFrom">Order Date (From)</label>
          <el-date-picker
            id="OrderDateFrom"
            v-model="selectedOrderDateFrom"
            type="date"
             :editable="false"
            format="dd-MMMM-yyyy"
            placeholder="From Date"
            @input="changeValue"

          ></el-date-picker>
        </div>

        <div class="col-md-3">
          <label for="OrderDateTo">Order Date (To)</label>
          <el-date-picker
            id="OrderDateTo"
            v-model="selectedOrderDateTo"
            type="date"
             :editable="false"
            format="dd-MMMM-yyyy"
            placeholder="To Date"
            @input="changeValue"

          ></el-date-picker>
        </div>
    
        <div class="col-md-3">
          <label for="DeliveryDateFrom">Delivery Date (From)</label>
          <el-date-picker
            id="DeliveryDateFrom"
            v-model="selectedDeliveryDateFrom"
            type="date"
             :editable="false"
            format="dd-MMMM-yyyy"
            placeholder="From Date"
            @input="changeValue"

          ></el-date-picker>
        </div>

        <div class="col-md-3">
          <label for="DeliveryDateTo">Delivery Date (To)</label>
          <el-date-picker
            id="DeliveryDateTo"
            v-model="selectedDeliveryDateTo"
            type="date"
             :editable="false"
            format="dd-MMMM-yyyy"
            placeholder="To Date"
            @input="changeValue"

          ></el-date-picker>
        </div>
      </div>
      <!-- 6th Row (Organization and Ratification) -->
       <div class="row more-top-padding">
        <div class="col-md-3">
          <label for="Organization">Organization:</label>
          <base-input :error="getError('organization')" aria-label="Organization">
              <treeselect
                @input="() => {filterApprover();changeValue()}"
                v-model="selectedOrganizationId"
                class="select-primary"
                name="organization"
                :multiple="false"
                :clearable="true"
                :searchable="true"
               
                :open-on-click="true"
                :open-on-focus="false"
                :clear-on-select="false"
                :close-on-select="true"
                :always-open="false"
                :append-to-body="false"
                search-nested
                :options="jointStaffOrganizations"
                placeholder="Organization"
            

              />
          </base-input>
        </div>

        <div class="col-md-3">
          <label>Service / Parent Organization:</label>
          <base-input :error="getError('organization')" aria-label="Organization">
          <treeselect 
                        v-model="serviceParent" name="ServicesDropDown" :multiple="false"
                        id="id" label="Name" :value-consists-of="'LEAF_PRIORITY'"
                        :openOnClick="true" :clearable="true" :searchable="true"
            @input="changeValue"
                        :options="serviceList"  placeholder="Select" />
          </base-input>
        </div>
        
        <div class="col-md-3">
          <label for="RatificationRequired">Ratification Required</label>
          <v-select
            id="RatificationRequired"
            v-model="selectedRatificationRequired"
            name="RatificationRequiredDropdown"
            :reduce="(item) => item.value"
            label="name"
            :options="ratificationRequiredOptions"
            @input="changeValue"

            placeholder="Select"
          ></v-select>
        </div>

        <div class="col-md-3">

        <label>Deliver to Country (Location) </label>
        <v-select
          v-model="selectedDeliveryCountryId"
          :reduce="(country) => country.countryId"
          @input="changeValue"
          label="name"
          :options="allCountries"
          placeholder="Select"
          data-vv-as="Delivery to Country (Location)"
          name="deliveryCountryId"
        ></v-select>
          
        </div>



       </div>
      <!-- 7th Row (Search and Clear Buttons) -->
      <div class="row more-top-padding">
        <div class="col-md-4 d-flex justify-content-start col-6">
          <base-button
            @click="initializeAllData()"
            type="danger"
            v-b-popover.hover.top="'Reset all fields!'"
          >
            <i class="tim-icons icon-alert-circle-exc"></i> Clear
          </base-button>
        </div>

        <div
          class="col-md-4 d-flex justify-content-md-center justify-content-end col-6"
        >
          <base-button
            @click="search()"
            :disabled="this.duringSubmit"
            type="primary"
            v-b-popover.hover.right="'Search results will appear below.'"
          >
            <i class="tim-icons icon-zoom-split"></i> Search
          </base-button>
        </div>
      </div>
      <hr />
      <br />

      <div>
        <h3>Search Results</h3>
        <SearchShowAllOrders ref="childEvents"></SearchShowAllOrders>
      </div>
    </div>
  </center>
</template>

<script>
import SearchShowAllOrders from "@/pages/SearchShowAllOrders.vue";
import Header from "@/components/App/Header.vue";
import { mapGetters, mapActions } from "vuex";
import { Select, Option, Tooltip } from "element-ui";
import Util from "@/util/util";
import Treeselect from "@riophae/vue-treeselect";
import Loading from 'src/components/LoadingPanel';
import { get } from "lodash";

export default {
  name: "Search",
  components: {
    Header,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    SearchShowAllOrders,
    Treeselect,
    Loading
  },
  async mounted() {
    this.isMounted = true;
    if (!this.user) {
      this.getUserByEmail()
    }
    this.$loaderApp.addRequest();
    await this.getAllStatuses();
    await this.getAllCountries();
    await this.getAllOperationTheatres();
    await this.getPaymentMethods();
    await this.getLssTypes();
    await this.getLogisticsUsers(true);
    await this.getFinanceUsers(true);
    await this.getUsers();
    await this.getFiscalYears();
    await this.clearSearchResults();
    await this.getAllServices();
    await this.getJointStaffOrganizations();
    this.setValuesonMounted();
    this.$loaderApp.completeRequest();
  },
  data() {
    return {
      duringSubmit: false,
      selectedAcsaRequisitionNumber: "",
      selectedBuyOrSell: "",
      buyOrSellOptions: [
        {
          id: "BUY",
          name: "Buy",
        },
        {
          id: "SELL",
          name: "Sell",
        },
      ],
      selectedStatus: "",
      selectedPartnerNation: "",
      selectedFiscalYear: "",
      selectedOperationTheater: "",
      selectedPurchaseOrder: "",
      selectedInvoiceNumber: "",
      selectedOrderId: "",
      selectedMethodOfPayment: "",
      selectedDeliveryCountryId: '',
      selectedLsssType: "",
      selectedCreatedBy: "",
      selectedAssignedLogisticsUser: "",
      selectedAssignedFinanceUser: "",
      selectedOrderDateFrom: "",
      selectedOrderDateTo: "",
      selectedStartPrice: "",
      selectedEndPrice: "",
      selectedDeliveryDateFrom: "",
      selectedDeliveryDateTo: "",
      organizationIds: [],
      selectedOrganizationId: null,
      serviceParent: null,
      statusOptions: [],
      selectedRatificationRequired: "",
      ratificationRequiredOptions: [
        {
          value: true,
          name: "Yes",
        },
        {
          value: false,
          name: "No",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
      partnerNationOptions: "countries/allCountries",
      operationTheaterOptions: "operationTheaters/allOperationTheatres",
      methodOfPaymentOptions: "paymentmethod/paymentMethods",
      lsssTypeOptions: "lsstype/allLssTypes",
      assignedLogisticsUserOptions: "users/logisticsUsers",
      assignedFinanceUserOptions: "users/financeUsers",
      createdByOptions: "users/allUsers",
      fiscalYears: "fiscalYears/fiscalYears",
      searchResults: "orders/searchResults",
      searchCriteria: "orders/searchCriteria",
      allServices: "services/services",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      searchValues: "orders/searchValues",
       allCountries: "countries/allCountries",
    }),
    fiscalYearStart() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear - 1, 9, 1).toISOString()
        : null;
    },
    fiscalYearEnd() {
      return this.selectedFiscalYear
        ? new Date(this.selectedFiscalYear, 8, 30).toISOString()
        : null;
    },
    serviceList: function () {
            if (this.allServices) {
                return this.allServices.reduce((names, node) => {
                    names.push({ id: node.serviceId, label: node.displayName, name: node.displayName }); // Use your custom field here
                    return names;
                }, []);
            }
        },
     selectedLogisticsUserLabel () {
      let selectedUser;
      if(this.selectedAssignedLogisticsUser) {
        selectedUser = this.assignedLogisticsUserOptions.find(user => user.id === this.selectedAssignedLogisticsUser
        );
      }
        return selectedUser ? selectedUser.nameLabel : 'No Logistics user selected';
    },
     selectedFinanceUserLabel () {
      let selectedUser;
      if(this.selectedAssignedFinanceUser) {
        selectedUser = this.assignedFinanceUserOptions.find(user => user.id === this.selectedAssignedFinanceUser);
      }
        return selectedUser ? selectedUser.nameLabel : 'No Logistics user selected';
    }
  },

  
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllCountries",
      getAllOperationTheatres: "operationTheaters/getAllOperationTheatres",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      getLssTypes: "lsstype/getLssTypes",
      getLogisticsUsers: "users/getLogisticsUsers",
      getFinanceUsers: "users/getFinanceUsers",
      getUsers: "users/getUsers",
      getFiscalYears: "fiscalYears/getFiscalYears",
      setSearchCriteria: "orders/setSearchCriteria",
      clearSearchCriteria: "orders/clearSearchCriteria",
      getSearchResults: "orders/getSearchResults",
      clearSearchResults: "orders/clearSearchResults",
      getUserByEmail: 'users/getUserByEmail',
      getJointStaffOrganizations: "organization/getJointStaffOrganizations",
      getAllServices: "services/getServices",
      setSearchValues: "orders/setSearchValues",
     

    }),
    handleLogin() {
      if (!this.isLoggedIn) {
        this.$router.push("Login");
      }
    },
  async initializeAllData() {
      await Object.assign(this.$data, this.$options.data());
      await this.getAllStatuses();
    },
    async getAllStatuses() {
      const response = await this.axios.get("/api/orderstatuses")
      this.statusOptions = response.data;
    },
    setValuesonMounted(){
      if(this.searchValues && Object.keys(this.searchValues).length > 0){
        this.selectedOrderId = this.searchValues.OrderId || "";
        this.selectedPartnerNation = this.searchValues.CountryId || "";
        this.selectedOperationTheater = this.searchValues.TheaterId || "";
        this.selectedAssignedLogisticsUser = this.searchValues.LogisticsUserId || "";
        this.selectedAssignedFinanceUser = this.searchValues.FinanceUserId || "";
        this.selectedCreatedBy = this.searchValues.CreatedUserId || "";
        this.selectedPurchaseOrder = this.searchValues.PurchaseOrderNumber || "";
        this.selectedInvoiceNumber = this.searchValues.InvoiceNumber || "";
        this.selectedAcsaRequisitionNumber = this.searchValues.RequisitionNumber || "";
        this.selectedLsssType = this.searchValues.LssTypeId || "";
        this.selectedBuyOrSell = this.searchValues.UsBuySell || "";
        this.selectedMethodOfPayment = this.searchValues.PaymentMethodId || "";
        this.selectedStatus = this.searchValues.OrderStatusId || "";
        this.selectedFiscalYear = this.searchValues.FiscalYear || "";
        this.selectedOrderDateFrom = this.searchValues.StartDate || "";
        this.selectedOrderDateTo = this.searchValues.EndDate || "";
        this.selectedDeliveryDateFrom = this.searchValues.DeliveryStartDate || "";
        this.selectedDeliveryDateTo = this.searchValues.DeliveryEndDate || "";
        this.selectedStartPrice = this.searchValues.StartTotal || "";
        this.selectedEndPrice = this.searchValues.EndTotal || "";
        this.organizationIds = this.searchValues.organizationIds || [];
        this.selectedOrganizationId = this.searchValues.OrganizationId || null;

        this.serviceParent = this.searchValues.serviceId || null;
        this.selectedRatificationRequired = (this.searchValues.IsRatificationRequired !== undefined) ? this.searchValues.IsRatificationRequired : "";
        this.selectedDeliveryCountryId = this.searchValues.DeliveryCountryId || null;
      }
       
    },
    changeValue(){
      if (!this.isMounted) return;
            let searchQuery = {
        OrderId: this.selectedOrderId,
        CountryId: this.selectedPartnerNation,
        TheaterId: this.selectedOperationTheater,
        LogisticsUserId: this.selectedAssignedLogisticsUser,
        FinanceUserId: this.selectedAssignedFinanceUser,
        CreatedUserId: this.selectedCreatedBy,
        PurchaseOrderNumber: this.selectedPurchaseOrder,
        InvoiceNumber: this.selectedInvoiceNumber,
        RequisitionNumber: this.selectedAcsaRequisitionNumber,
        LssTypeId: this.selectedLsssType,
        UsBuySell: this.selectedBuyOrSell,
        PaymentMethodId: this.selectedMethodOfPayment,
        OrderStatusId: this.selectedStatus,
        FiscalYear: this.selectedFiscalYear,
        FiscalYearStart: this.fiscalYearStart,
        FiscalYearEnd: this.fiscalYearEnd,
        StartDate: this.selectedOrderDateFrom,
        EndDate: this.selectedOrderDateTo,
        DeliveryStartDate: this.selectedDeliveryDateFrom,
        DeliveryEndDate: this.selectedDeliveryDateTo,
        StartTotal: this.selectedStartPrice,
        EndTotal: this.selectedEndPrice,
        PageNumber: 1,
        organizationIds: this.organizationIds,
        serviceId: this.serviceParent,
        IsRatificationRequired: this.selectedRatificationRequired,
        DeliveryCountryId: this.selectedDeliveryCountryId,
        OrganizationId: this.selectedOrganizationId
      };
       if (JSON.stringify(searchQuery) !== JSON.stringify(this.$store.state.orders.searchValues)) {
    Object.keys(searchQuery).forEach(key => {
    if (searchQuery[key] !== this.searchValues[key]) {
        this.setSearchValues({ key, value: searchQuery[key] });
    }
  });
  }
    },
    async search() {
      // if(this.duringSubmit) {
      //   return; // don't want user to keep click searching if the previous search hasn't return yet.
      // }
      if(this.$loaderApp.checkoutPendingCount() !== 0) {
        return;
      }
      this.clearSearchResults();
      this.$refs.childEvents.disableEverything();

      let searchQuery = {
        OrderId: this.selectedOrderId,
        CountryId: this.selectedPartnerNation,
        TheaterId: this.selectedOperationTheater,
        LogisticsUserId: this.selectedAssignedLogisticsUser,
        FinanceUserId: this.selectedAssignedFinanceUser,
        CreatedUserId: this.selectedCreatedBy,
        PurchaseOrderNumber: this.selectedPurchaseOrder,
        InvoiceNumber: this.selectedInvoiceNumber,
        RequisitionNumber: this.selectedAcsaRequisitionNumber,
        LssTypeId: this.selectedLsssType,
        UsBuySell: this.selectedBuyOrSell,
        PaymentMethodId: this.selectedMethodOfPayment,
        OrderStatusId: this.selectedStatus,
        FiscalYear: this.selectedFiscalYear,
        FiscalYearStart: this.fiscalYearStart,
        FiscalYearEnd: this.fiscalYearEnd,
        StartDate: this.selectedOrderDateFrom,
        EndDate: this.selectedOrderDateTo,
        DeliveryStartDate: this.selectedDeliveryDateFrom,
        DeliveryEndDate: this.selectedDeliveryDateTo,
        StartTotal: this.selectedStartPrice,
        EndTotal: this.selectedEndPrice,
        PageNumber: 1,
        organizationIds: this.organizationIds,
        serviceId: this.serviceParent,
        IsRatificationRequired: this.selectedRatificationRequired,
        DeliveryCountryId: this.selectedDeliveryCountryId,
        OrganizationId : this.selectedOrganizationId

      };

      if (!Util.isNullOrEmpty(this.searchCriteria.SearchText)) {
        searchQuery.SearchText = this.searchCriteria.SearchText;
      }

      if (!Util.isNullOrEmpty(this.searchResults)) {
        searchQuery.ResultsPerPage = this.searchResults.pageSize;
      }
      this.$refs.childEvents.handleNewSearch();
      this.setSearchCriteria(searchQuery);

      this.duringSubmit = true;
      this.$loaderApp.addRequest();

      await this.getSearchResults();

      if (!Util.isNullOrEmpty(this.searchResults.results)) {
        this.$refs.childEvents.enableEverything();
      } else {
        this.$refs.childEvents.disableEverything();
      }
      this.duringSubmit = false;
      this.$loaderApp.completeRequest();
    },

    // DFS to find the parent
    findParent(child) {
      if(child.id === this.organizationId)
        return child;
      let len = child.children.length;
      if(len > 0) {
        for(let i=0; i<len; i++) {
          let children = child.children[i];
          if(children.id === this.organizationId) {
            return children;
          } else {
            let ret = this.findParent(children);
            if(ret.id === this.organizationId){
              return ret;
            }
          }
        }
      }
      return child;
    },
    // DFS to find all the children of a parent
    findAllChildrenId(children) {
      for(let i=0; i<children.children.length; i++) {
        let child = children.children[i];
        this.organizationIds.push(child.id);
        this.findAllChildrenId(child);
      }
    },
    getError(fieldName) {
        return this.errors.first(fieldName);
    },
    filterApprover() {
      if(this.organizationId !== undefined) {
        this.organizationIds = [];

        // find the parent
        var parent = this.findParent(this.jointStaffOrganizations[0]);

        // find the children;
        this.organizationIds.push(parent.id);
        this.findAllChildrenId(parent);
      } else {
        this.organizationIds = [];
      }
     
    }
  },
  
};


</script>